import { render, staticRenderFns } from "./comp_BrandsDialog.vue?vue&type=template&id=904d3036&scoped=true&"
import script from "./comp_BrandsDialog.vue?vue&type=script&lang=js&"
export * from "./comp_BrandsDialog.vue?vue&type=script&lang=js&"
import style0 from "./comp_BrandsDialog.vue?vue&type=style&index=0&id=904d3036&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904d3036",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VDialog,VIcon,VList,VListItem,VListItemTitle,VProgressCircular,VVirtualScroll})
